import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from '../../constant';
import Loader from '../../component/common/Loader';
import { getSelectedOrActiveCycle, getEmployeeAbsence, saveEmployeeAbsence, updateEmployeeAbsence } from '../../actions/AppraisalCycleAction';

class PeriodOfAbsence extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false,
            employeeCode: '',
            appraisalCycleId: null,
            cycleStartDate: '',
            cycleEndDate: '',
            isExisting: false,
            onLeaveOtherThanCL: [{ periodFrom: '', periodTo: '', leaveType: '', remarks: '', error: '' }],
            others: [{ periodFrom: '', periodTo: '', leaveType: '', remarks: '', error: '' }],
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const employeeCode = this.props.match.params.code || '';
        document.title = 'Period of Absence - ' + CONSTANT.organisation.name;
        this.setState({ employeeCode }, () => {
            this.loadActiveCycleAndData();
        });
    }

    loadActiveCycleAndData = () => {
        this.setState({ showLoader: true });
        getSelectedOrActiveCycle().then((res: any) => {
            const cycle = res?.result;
            if (!cycle || !cycle.id) {
                alert('No appraisal cycle selected. Please select a cycle in the top bar.');
                this.setState({ showLoader: false });
                return;
            }
            const cycleStart = cycle.startDate || cycle.start_date || '';
            const cycleEnd = cycle.endDate || cycle.end_date || '';
            this.setState({
                appraisalCycleId: cycle.id,
                cycleStartDate: this.formatDate(cycleStart),
                cycleEndDate: this.formatDate(cycleEnd),
            }, () => {
                this.loadAbsenceData();
            });
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    formatDate = (dateStr: string) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    loadAbsenceData = () => {
        const { employeeCode, appraisalCycleId } = this.state;
        getEmployeeAbsence({ employeeCode, appraisalCycleId }).then((res: any) => {
            const data = res?.result || res || [];
            if (Array.isArray(data) && data.length > 0) {
                const leaveRows = data
                    .filter((item: any) => item.absence_type === 'leave')
                    .map((item: any) => ({
                        periodFrom: this.formatDate(item.period_from),
                        periodTo: this.formatDate(item.period_to),
                        leaveType: item.leave_type || '',
                        remarks: item.remarks || '',
                    }));
                const othersRows = data
                    .filter((item: any) => item.absence_type === 'others')
                    .map((item: any) => ({
                        periodFrom: this.formatDate(item.period_from),
                        periodTo: this.formatDate(item.period_to),
                        leaveType: item.leave_type || '',
                        remarks: item.remarks || '',
                    }));
                this.setState({
                    isExisting: true,
                    onLeaveOtherThanCL: leaveRows.length > 0 ? leaveRows : [{ periodFrom: '', periodTo: '', leaveType: '', remarks: '' }],
                    others: othersRows.length > 0 ? othersRows : [{ periodFrom: '', periodTo: '', leaveType: '', remarks: '' }],
                });
            }
            this.setState({ showLoader: false });
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    validateDateInCycle = (dateStr: string) => {
        if (!dateStr) return '';
        const { cycleStartDate, cycleEndDate } = this.state;
        if (!cycleStartDate || !cycleEndDate) return '';
        if (dateStr < cycleStartDate || dateStr > cycleEndDate) {
            return `Date must be within the appraisal cycle (${cycleStartDate} to ${cycleEndDate})`;
        }
        return '';
    };

    validateRow = (row: any) => {
        const fromError = this.validateDateInCycle(row.periodFrom);
        if (fromError) return fromError;
        const toError = this.validateDateInCycle(row.periodTo);
        if (toError) return toError;
        if (row.periodFrom && row.periodTo && row.periodFrom > row.periodTo) {
            return '"Period From" cannot be after "Period To"';
        }
        return '';
    };

    handleLeaveRowChange = (index: number, field: string, value: string) => {
        const rows = [...this.state.onLeaveOtherThanCL];
        rows[index] = { ...rows[index], [field]: value };
        rows[index].error = this.validateRow(rows[index]);
        this.setState({ onLeaveOtherThanCL: rows });
    };

    handleOthersRowChange = (index: number, field: string, value: string) => {
        const rows = [...this.state.others];
        rows[index] = { ...rows[index], [field]: value };
        rows[index].error = this.validateRow(rows[index]);
        this.setState({ others: rows });
    };

    addLeaveRow = () => {
        this.setState({
            onLeaveOtherThanCL: [...this.state.onLeaveOtherThanCL, { periodFrom: '', periodTo: '', leaveType: '', remarks: '' }],
        });
    };

    addOthersRow = () => {
        this.setState({
            others: [...this.state.others, { periodFrom: '', periodTo: '', leaveType: '', remarks: '' }],
        });
    };

    removeLeaveRow = (index: number) => {
        const rows = this.state.onLeaveOtherThanCL.filter((_: any, i: number) => i !== index);
        this.setState({ onLeaveOtherThanCL: rows });
    };

    removeOthersRow = (index: number) => {
        const rows = this.state.others.filter((_: any, i: number) => i !== index);
        this.setState({ others: rows });
    };

    buildAbsencesPayload = () => {
        const { onLeaveOtherThanCL, others } = this.state;
        const absences: any[] = [];

        onLeaveOtherThanCL.forEach((row: any) => {
            if (row.periodFrom || row.periodTo || row.leaveType || row.remarks) {
                absences.push({
                    absenceType: 'leave',
                    periodFrom: row.periodFrom,
                    periodTo: row.periodTo,
                    leaveType: row.leaveType,
                    remarks: row.remarks,
                });
            }
        });

        others.forEach((row: any) => {
            if (row.periodFrom || row.periodTo || row.leaveType || row.remarks) {
                absences.push({
                    absenceType: 'others',
                    periodFrom: row.periodFrom,
                    periodTo: row.periodTo,
                    leaveType: row.leaveType,
                    remarks: row.remarks,
                });
            }
        });

        return absences;
    };

    onSubmit = (e: any) => {
        e.preventDefault();
        const { employeeCode, appraisalCycleId, isExisting } = this.state;

        if (!appraisalCycleId) {
            alert('No active appraisal cycle found');
            return;
        }

        const { onLeaveOtherThanCL, others } = this.state;
        const allRows = [...onLeaveOtherThanCL, ...others];
        const hasErrors = allRows.some((row: any) => row.error);
        if (hasErrors) {
            alert('Please fix date errors before saving. Dates must be within the appraisal cycle.');
            return;
        }

        const absences = this.buildAbsencesPayload();
        if (absences.length === 0) {
            alert('Please add at least one absence entry');
            return;
        }

        this.setState({ showLoader: true });
        const payload = { employeeCode, appraisalCycleId, absences };

        const apiCall = isExisting ? updateEmployeeAbsence : saveEmployeeAbsence;
        apiCall(payload).then((res: any) => {
            this.setState({ showLoader: false });
            if (res?.status === 'failed') {
                alert(res.error || 'Failed to save period of absence');
            } else {
                this.setState({ isExisting: true });
                alert('Period of absence saved successfully!');
            }
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    render() {
        const { showLoader, employeeCode, onLeaveOtherThanCL, others } = this.state;

        return (
            <div className="container-fluid mb-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card homedob">
                            <div className="row">
                                <div className="col-md-8">
                                    <h1 className="page-title">
                                        <i className="fa fa-calendar-times-o text-warning mr-2" />
                                        Period of absence on leave, etc. during the year
                                    </h1>
                                    <p className="text-muted mb-0">Employee Code: <strong>{employeeCode}</strong></p>
                                </div>
                                <div className="col-md-4 text-right">
                                    <button
                                        className="btn btn-sm cancel-button"
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        <i className="fa fa-arrow-left mr-2" />
                                        Back
                                    </button>
                                </div>
                            </div>

                            {showLoader && <Loader />}

                            <form onSubmit={this.onSubmit}>
                                {/* On Leave other than Casual Leave */}
                                <div className="mt-4">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5 className="mb-0">
                                            <i className="fa fa-plane text-primary mr-2" />
                                            On Leave other than Casual Leave
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={this.addLeaveRow}
                                        >
                                            <i className="fa fa-plus mr-1" />
                                            Add Row
                                        </button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <thead className="table-light">
                                                <tr className="text-center">
                                                    <th style={{ width: '5%' }}>#</th>
                                                    <th style={{ width: '20%' }}>Period From</th>
                                                    <th style={{ width: '20%' }}>Period To</th>
                                                    <th style={{ width: '20%' }}>Leave Type</th>
                                                    <th style={{ width: '25%' }}>Remarks</th>
                                                    <th style={{ width: '10%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {onLeaveOtherThanCL.map((row: any, index: number) => (
                                                    <tr key={index}>
                                                        <td className="text-center align-middle">{index + 1}</td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className={`form-control form-control-sm ${row.error ? 'is-invalid' : ''}`}
                                                                value={row.periodFrom}
                                                                onChange={(e) => this.handleLeaveRowChange(index, 'periodFrom', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className={`form-control form-control-sm ${row.error ? 'is-invalid' : ''}`}
                                                                value={row.periodTo}
                                                                onChange={(e) => this.handleLeaveRowChange(index, 'periodTo', e.target.value)}
                                                            />
                                                            {row.error && <div className="text-danger small mt-1">{row.error}</div>}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.leaveType}
                                                                onChange={(e) => this.handleLeaveRowChange(index, 'leaveType', e.target.value)}
                                                                placeholder="e.g. Earned Leave, HPL, EOL"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.remarks}
                                                                onChange={(e) => this.handleLeaveRowChange(index, 'remarks', e.target.value)}
                                                                placeholder="Remarks"
                                                            />
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            {onLeaveOtherThanCL.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => this.removeLeaveRow(index)}
                                                                    title="Remove row"
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Others */}
                                <div className="mt-4">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5 className="mb-0">
                                            <i className="fa fa-info-circle text-secondary mr-2" />
                                            Others (specify)
                                        </h5>
                                        {/* <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={this.addOthersRow}
                                        >
                                            <i className="fa fa-plus mr-1" />
                                            Add Row
                                        </button> */}
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <thead className="table-light">
                                                <tr className="text-center">
                                                    <th style={{ width: '5%' }}>#</th>
                                                    <th style={{ width: '20%' }}>Period From</th>
                                                    <th style={{ width: '20%' }}>Period To</th>
                                                    <th style={{ width: '20%' }}>Type</th>
                                                    <th style={{ width: '25%' }}>Remarks</th>
                                                    <th style={{ width: '10%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {others.map((row: any, index: number) => (
                                                    <tr key={index}>
                                                        <td className="text-center align-middle">{index + 1}</td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className={`form-control form-control-sm ${row.error ? 'is-invalid' : ''}`}
                                                                value={row.periodFrom}
                                                                onChange={(e) => this.handleOthersRowChange(index, 'periodFrom', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className={`form-control form-control-sm ${row.error ? 'is-invalid' : ''}`}
                                                                value={row.periodTo}
                                                                onChange={(e) => this.handleOthersRowChange(index, 'periodTo', e.target.value)}
                                                            />
                                                            {row.error && <div className="text-danger small mt-1">{row.error}</div>}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.leaveType}
                                                                onChange={(e) => this.handleOthersRowChange(index, 'leaveType', e.target.value)}
                                                                placeholder="e.g. Deputation, Training"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.remarks}
                                                                onChange={(e) => this.handleOthersRowChange(index, 'remarks', e.target.value)}
                                                                placeholder="Remarks"
                                                            />
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            {others.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => this.removeOthersRow(index)}
                                                                    title="Remove row"
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end mt-4 mb-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary mr-2"
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        <i className="fa fa-times mr-1" />
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        <i className="fa fa-save mr-1" />
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PeriodOfAbsence);
